// @flow
import DateRange from 'common/domain/DateRange';
import Spot from 'common/modules/spots/domain/Spot';
import SpotAPI from '../services/SpotAPI';
import type { Dispatch, GetState } from '../../../types/Store';
import { getToken, getStation } from '../../authentication/session/reducers/sessionReducer';

export const ADD_SPOTS = 'spotActions/ADD_SPOTS';
export const ADD_SPOTS_SUCCESS = 'spotActions/ADD_SPOTS_SUCCESS';
export const ADD_SPOTS_FAILED = 'spotActions/ADD_SPOTS_FAILED';

export const UPDATE_SPOTS = 'spotActions/UPDATE_SPOTS';
export const UPDATE_SPOTS_SUCCESS = 'spotActions/UPDATE_SPOTS_SUCCESS';
export const UPDATE_SPOTS_FAILED = 'spotActions/UPDATE_SPOTS_FAILED';

export const DELETE_SPOTS = 'spotActions/DELETE_SPOTS';
export const DELETE_SPOTS_SUCCESS = 'spotActions/DELETE_SPOTS_SUCCESS';
export const DELETE_SPOTS_FAILED = 'spotActions/DELETE_SPOTS_FAILED';

export const FETCH_SPOTS = 'spotActions/FETCH_SPOTS';
export const FETCH_SPOTS_SUCCESS = 'spotActions/FETCH_SPOTS_SUCCESS';
export const FETCH_SPOTS_FAILED = 'spotActions/FETCH_SPOTS_FAILED';

export const FETCH_SPOT_INVENTORY = 'spotActions/FETCH_SPOT_INVENTORY';
export const FETCH_SPOT_INVENTORY_SUCCESS = 'spotActions/FETCH_SPOT_INVENTORY_SUCCESS';
export const FETCH_SPOT_INVENTORY_FAILED = 'spotActions/FETCH_SPOT_INVENTORY_FAILED';

export const addSpots = (spots: Spot[]): any => {
  return async (dispatch: Dispatch, getState: GetState): Promise<*> => {
    try {
      dispatch({ type: ADD_SPOTS });

      const token = getToken(getState());
      const station = getStation(getState());

      const addedSpots = await SpotAPI.addSpots(spots, station, token);

      dispatch({ type: ADD_SPOTS_SUCCESS, spots: addedSpots });
    } catch (error) {
      dispatch({ type: ADD_SPOTS_FAILED });
      throw error;
    }
  };
};

export const updateSpots = (spots: Spot[]): any => {
  return async (dispatch: Dispatch, getState: GetState): Promise<*> => {
    try {
      dispatch({ type: UPDATE_SPOTS });

      const token = getToken(getState());
      const station = getStation(getState());

      await SpotAPI.updateSpots(spots, station, token);

      dispatch({ type: UPDATE_SPOTS_SUCCESS, spots });
    } catch (error) {
      dispatch({ type: UPDATE_SPOTS_FAILED });
      throw error;
    }
  };
};

export const deleteSpots = (spots: Spot[]): any => {
  return async (dispatch: Dispatch, getState: GetState): Promise<*> => {
    try {
      dispatch({ type: DELETE_SPOTS });

      const token = getToken(getState());
      const station = getStation(getState());

      await SpotAPI.deleteSpots(spots, station, token);

      dispatch({ type: DELETE_SPOTS_SUCCESS, spots });
    } catch (error) {
      dispatch({ type: DELETE_SPOTS_FAILED });
      throw error;
    }
  };
};

export const fetchSpots = (dateRange: DateRange): any => {
  return async (dispatch: Dispatch, getState: GetState): Promise<*> => {
    try {
      dispatch({ type: FETCH_SPOTS });

      const token = getToken(getState());
      const station = getStation(getState());

      const spots = await SpotAPI.fetchSpotsInDateRange(dateRange, station, token);

      dispatch({ type: FETCH_SPOTS_SUCCESS, spots });
    } catch (error) {
      dispatch({ type: FETCH_SPOTS_FAILED, error });
    }
  };
};

export const fetchCampaignSpots = (dateRange: DateRange, campaignReference: string): any => {
  return async (dispatch: Dispatch, getState: GetState): Promise<*> => {
    try {
      dispatch({ type: FETCH_SPOTS });

      const token = getToken(getState());
      const station = getStation(getState());

      const spots = await SpotAPI.fetchSpotsForCampaignInDateRange(dateRange, campaignReference, station, token);

      dispatch({ type: FETCH_SPOTS_SUCCESS, spots });
    } catch (error) {
      dispatch({ type: FETCH_SPOTS_FAILED, error });
    }
  };
};

export const fetchSpotInventory = (dateRange: DateRange): any => {
  return async (dispatch: Dispatch, getState: GetState): Promise<*> => {
    try {
      dispatch({ type: FETCH_SPOT_INVENTORY });

      const token = getToken(getState());
      const station = getStation(getState());

      const inventory = await SpotAPI.fetchInventoryInDateRange(dateRange, station, token);

      dispatch({ type: FETCH_SPOT_INVENTORY_SUCCESS, inventory });
    } catch (error) {
      dispatch({ type: FETCH_SPOT_INVENTORY_FAILED, error });
    }
  };
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/spots/actions/spotActions.js